module.exports = __webpack_public_path__ + "img/icon_dashboard_todayworkingtime03.7835b51.svg";